var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeligramHomeColord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5C10.824 5 5 10.824 5 18C5 25.176 10.824 31 18 31C25.176 31 31 25.176 31 18C31 10.824 25.176 5 18 5ZM24.032 13.84C23.837 15.894 22.992 20.886 22.563 23.187C22.381 24.162 22.017 24.487 21.679 24.526C20.925 24.591 20.353 24.032 19.625 23.551C18.481 22.797 17.831 22.329 16.726 21.601C15.439 20.756 16.271 20.288 17.012 19.534C17.207 19.339 20.535 16.31 20.6 16.037C20.609 15.9957 20.6078 15.9527 20.5965 15.9119C20.5852 15.8712 20.5641 15.8338 20.535 15.803C20.457 15.738 20.353 15.764 20.262 15.777C20.145 15.803 18.325 17.012 14.776 19.404C14.256 19.755 13.788 19.937 13.372 19.924C12.904 19.911 12.02 19.664 11.357 19.443C10.538 19.183 9.901 19.04 9.953 18.585C9.979 18.351 10.304 18.117 10.915 17.87C14.711 16.219 17.233 15.127 18.494 14.607C22.108 13.099 22.849 12.839 23.343 12.839C23.447 12.839 23.694 12.865 23.85 12.995C23.98 13.099 24.019 13.242 24.032 13.346C24.019 13.424 24.045 13.658 24.032 13.84Z",
    fill: "url(#paint0_linear_9872_7590)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9872_7590",
    x1: 22.5,
    y1: 11.25,
    x2: 12.5,
    y2: 25.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeligramHomeColord);
export default __webpack_public_path__ + "static/media/teligram-home-colord.05646e3ee416c140f37b0542f04e4d44.svg";
export { ForwardRef as ReactComponent };